/* ============================================================
   cb-nav.js — V2.2 Desktop-Only Dropdown Controller
   Handles: Desktop mega menus, filialen, standard dropdowns
   Does NOT touch: Mobile menu (handled by theme header.js)
   ============================================================ */

(function () {
  'use strict';

  var CFG = {
    openDelay:       60,
    closeDelay:      280,
    switchDelay:     0,
    scrollThreshold: 40,
    mobileBreak:     960
  };

  var activeItem  = null;
  var openTimer   = null;
  var closeTimer  = null;
  var scrollStart = null;
  var initialized = false;

  function isMobile() {
    return window.innerWidth <= CFG.mobileBreak;
  }

  function init() {
    if (initialized) return;

    /* Only run on desktop */
    if (isMobile()) return;

    initialized = true;

    var megaParents = document.querySelectorAll('.menu-item-has-megamenu');
    var allParents = document.querySelectorAll(
      '.thb-full-menu > .menu-item-has-children, .thb-full-menu > .menu-item-has-megamenu'
    );

    if (!allParents.length) return;

    /* Neutralize theme desktop listeners by cloning links */
    allParents.forEach(function(item) {
      var link = item.querySelector(':scope > a, :scope > .thb-full-menu--link');
      if (link) {
        var newLink = link.cloneNode(true);
        link.parentNode.replaceChild(newLink, link);
      }
    });

    /* Re-query fresh elements */
    var freshMega = document.querySelectorAll('.thb-full-menu > .menu-item-has-megamenu');
    var freshAll = document.querySelectorAll(
      '.thb-full-menu > .menu-item-has-children, .thb-full-menu > .menu-item-has-megamenu'
    );

    /* Clean up any leftover states */
    freshAll.forEach(function(item) {
      item.classList.remove('open', 'closing');
    });

    /* Setup handlers */
    setupMega(freshMega);
    setupStandard(freshAll);
    setupGlobal();
    setupFilialen();
  }

  /* ── Open / Close / Switch ── */

  function openDropdown(item) {
    if (isMobile() || activeItem === item) return;
    clearTimeout(openTimer);
    clearTimeout(closeTimer);

    var delay = activeItem ? CFG.switchDelay : CFG.openDelay;

    openTimer = setTimeout(function() {
      if (activeItem && activeItem !== item) {
        activeItem.classList.remove('open');
        activeItem.classList.add('closing');
        var prev = activeItem;
        setTimeout(function() { prev.classList.remove('closing'); }, 200);
      }
      item.classList.remove('closing');
      item.classList.add('open');
      activeItem = item;
      scrollStart = window.scrollY;
      staggerContent(item);
      updateFilialenTotal(item);
    }, delay);
  }

  function closeDropdown(immediate) {
    if (isMobile()) return;
    clearTimeout(openTimer);
    clearTimeout(closeTimer);

    var doClose = function() {
      if (activeItem) {
        activeItem.classList.remove('open');
        activeItem.classList.add('closing');
        var prev = activeItem;
        setTimeout(function() { prev.classList.remove('closing'); }, 250);
        activeItem = null;
        scrollStart = null;
      }
    };

    if (immediate) doClose();
    else closeTimer = setTimeout(doClose, CFG.closeDelay);
  }

  function cancelClose() { clearTimeout(closeTimer); }

  /* ── Stagger animation ── */

  function staggerContent(item) {
    var dropdown = item.querySelector(
      '.sub-menu, .mega-menu-container, .cb-mega, .cb-filialen-drop'
    );
    if (!dropdown) return;

    var targets = dropdown.querySelectorAll(
      '.cb-filialen-drop__card, .sub-menu > li, .cb-mega__col, ' +
      '.mega-menu-container > .row > *, [data-stagger]'
    );
    if (!targets.length) return;

    targets.forEach(function(el, i) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(6px)';
      el.style.transition = 'none';
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          el.style.transition =
            'opacity 0.28s cubic-bezier(0.16,1,0.3,1) ' + (i * 0.035) + 's, ' +
            'transform 0.28s cubic-bezier(0.16,1,0.3,1) ' + (i * 0.035) + 's';
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
        });
      });
    });
  }

  /* ── Mega menu hover ── */

  function setupMega(items) {
    items.forEach(function(item) {
      item.addEventListener('mouseenter', function() {
        if (isMobile()) return;
        cancelClose();
        openDropdown(item);
      });
      item.addEventListener('mouseleave', function() {
        if (isMobile()) return;
        closeDropdown(false);
      });
    });
  }

  /* ── Standard dropdowns ── */

  function setupStandard(items) {
    items.forEach(function(item) {
      if (item.classList.contains('menu-item-has-megamenu')) return;
      item.addEventListener('mouseenter', function() {
        if (isMobile()) return;
        if (activeItem) closeDropdown(true);
        item.classList.add('open');
      });
      item.addEventListener('mouseleave', function() {
        if (isMobile()) return;
        item.classList.remove('open');
      });
    });
  }

  /* ── Global: click outside, escape, scroll ── */

  function setupGlobal() {
    document.addEventListener('click', function(e) {
      if (isMobile()) return;
      if (!e.target.closest('.thb-full-menu')) {
        closeDropdown(true);
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeDropdown(true);
    });

    window.addEventListener('scroll', function() {
      if (!activeItem || scrollStart === null) return;
      if (Math.abs(window.scrollY - scrollStart) > CFG.scrollThreshold) {
        closeDropdown(true);
      }
    }, { passive: true });
  }

  /* ── Filialen totals ── */

  function setupFilialen() {
    document.querySelectorAll('.cb-filialen-drop__card').forEach(function(card) {
      var parent = card.closest('.menu-item-has-megamenu');
      if (!parent) return;
      card.addEventListener('mouseenter', function() {
        var totalEl = parent.querySelector('.cb-filialen-drop__total');
        var countNum = card.querySelector('.cb-filialen-drop__count-num');
        var name = card.querySelector('.cb-filialen-drop__name');
        if (totalEl && countNum) {
          totalEl.textContent = countNum.textContent + ' Bikes in ' +
            (name ? name.textContent : 'dieser Filiale');
        }
      });
      card.addEventListener('mouseleave', function() {
        updateFilialenTotal(parent);
      });
    });
  }

  function updateFilialenTotal(item) {
    var counts = item.querySelectorAll('.cb-filialen-drop__count-num');
    var totalEl = item.querySelector('.cb-filialen-drop__total');
    if (!totalEl || !counts.length) return;
    var total = 0;
    counts.forEach(function(c) { total += parseInt(c.textContent) || 0; });
    if (total > 0) totalEl.textContent = total + ' Bikes verfügbar';
  }

  /* ── Boot ── */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(init, 80);
    });
  } else {
    setTimeout(init, 80);
  }

  /* Re-init on resize crossing breakpoint */
  var wasMobile = window.innerWidth <= CFG.mobileBreak;
  window.addEventListener('resize', function() {
    var nowMobile = window.innerWidth <= CFG.mobileBreak;
    if (wasMobile && !nowMobile && !initialized) {
      init();
    }
    wasMobile = nowMobile;
  });

})();